export const ActionNames = Object.freeze({
  createCard: "CREATE_CARD",
  deleteCard: "DELETE_CARD",
  editCard: "EDIT_CARD",
  editCardSignatures: "EDIT_CARD_SIGNATURES",
  signCard: "SIGN_CARD",
  removeCardSignature: "REMOVE_CARD_SIGNATURE",
  viewProject: "VIEW_PROJECT",
  createProject: "CREATE_PROJECT",
  manageProject: "MANAGE_PROJECT",
  searchAllCards: "SEARCH_ALL_CARDS",
  exportCards: "EXPORT_CARDS",
  exportEmails: "EXPORT_EMAILS",
  viewCardErrors: "VIEW_CARD_ERRORS",
});
